import {
	requests
}from "../../../../api/agent"

export default {
	getList       : (params) => requests.getWithParams('/ReCharacteristic/GetList', params),
	create        : (params) => requests.post('/ReCharacteristic/Create', params),
	update        : (params) => requests.post('/ReCharacteristic/Update', params),
	delete        : (params) => requests.post('/ReCharacteristic/Delete', params),
	restore       : (params) => requests.post('/ReCharacteristic/Restore', params),
	getPaged      : (params) => requests.post('/ReCharacteristic/GetPagedActual', params),
	getPagedAll   : (params) => requests.post('/ReCharacteristic/GetPagedAll', params),
	getPagedAudit : (params) => requests.getWithParams('/ReCharacteristic/GetPagedAudit', params)
}